import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Entry } from '../models/entry';
import { EntryLine } from '../models/entry-line';
import { Warehouse } from '../models/warehouse';

@Injectable({
  providedIn: 'root'
})
export class InventoryService {

    constructor(private http:HttpClient) { }

    postEntry(entry:Entry) : Promise<Entry> {
      return this.http.post<Entry>('/api/purchases/entry', entry)
        .toPromise();
    }

    getReport(date1:Date, date2:Date, type:string = null, ids:string = null, isSap:boolean = false) : Promise<any> {
      if (!type) {
        if(!isSap){
          return this.http.get<any>('/api/purchases/entry/report', {params: {date1: date1.toString(), date2:date2.toString()}}).toPromise();
        }else{
          return this.http.get<any>('/api/purchases/entry/report', {params: {date1: date1.toString(), date2:date2.toString(), is_sap: 'true'}}).toPromise();
        }
      } else {
        return this.http.get<any>('/api/purchases/entry/report', {params: {type, date1: date1.toString(), date2:date2.toString(), ids}}).toPromise();
      }
    }

    postInvoiceLine(entryLine:EntryLine){
      return this.http.post<EntryLine>('/api/purchases/entry-line',entryLine).toPromise();
    }

    getEntriesByDates(date1:Date, date2:Date) : Promise<Entry[]> {
      return this.http.get<Entry[]>('/api/purchases/entry', {params: {date1: date1.toString(), date2: date2.toString()}})
        .toPromise();
    }
  
    getOpenEntries() : Promise<Entry[]> {
      return this.http.get<Entry[]>('/api/purchases/entry/open')
        .toPromise();
    }

    getWarehouses(inventory = false) : Promise<Warehouse[]> {
      if (inventory) {
        return this.http.get<Warehouse[]>('/api/warehouse', {params: {inventory: 'true'}})
          .toPromise();
      } else {
          return this.http.get<Warehouse[]>('/api/warehouse')
            .toPromise();
      }
    }

    getEntry(entry_id) : Promise<Entry> {
      return this.http.get<Entry>('/api/purchases/entry/' + entry_id)
        .toPromise();
    }

    getInvoiceLessEntries() : Promise<Entry[]> {
      return this.http.get<Entry[]>('/api/purchases/entry/invoiceless')
        .toPromise();
    }
  
    deleteEntry(params) : Promise<any> {
      return this.http.get<any>('/api/purchases/entry/delete', {params})
        .toPromise();
    }

    authorizeEntry(entry:Entry) : Promise<Entry> {
      return this.http.post<Entry>('/api/purchases/entry/' + entry.id + '/authorize', {})
        .toPromise();
    }

    authorizeEntryLines(lines) : Promise<Entry> {
      return this.http.post<Entry>('/api/purchases/entry/auth/lines', {lines})
        .toPromise();
    }

    authorizeOutput(lines) : Promise<Entry> {
      return this.http.post<Entry>('/api/purchases/entry/auth/output', {lines})
        .toPromise();
    }
}